import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import FixOrderRecoverItemPage from "./pages/FixOrderRecoverItemPage.vue";

export const FixOrderRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "fixOrder"
) => [
  {
    name: "FixOrderRecoverItemPage",
    path: `${prefix}/recoverItem`,
    component: FixOrderRecoverItemPage,
    meta: { title: "Recover Item Page" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.FIX_ACTION)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
